import { render, staticRenderFns } from "./matchingPage.vue?vue&type=template&id=320e91c4&"
import script from "./matchingPage.vue?vue&type=script&lang=js&"
export * from "./matchingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports